import { pathOr } from 'ramda';
import buildURLWithParams from '../browserUtils/buildURLWithParams';
import getLocaleFromUrl from '../locale/getLocaleFromUrl';
const buildGoogleMapsURL = (options = {}) => {
    const client = pathOr('gme-hmhennesmauritzab', ['hm', 'options', 'googleMapApiKey'], window);
    const channel = pathOr('storelocator_goe', ['hm', 'options', 'googleMapApiChannel'], window);
    const [language, region] = (getLocaleFromUrl() || 'en_gb').split(/[-_]/);
    const URL = 'https://maps.googleapis.com/maps/api/js';
    const params = Object.assign({ client,
        language,
        region,
        channel, libraries: 'places', v: '3' }, options);
    return buildURLWithParams({ base: URL, params });
};
export default buildGoogleMapsURL;
//# sourceMappingURL=buildGoogleMapsURL.js.map